import { render, staticRenderFns } from "./TipoRequestsTasksFormater.vue?vue&type=template&id=9e7813a2&scoped=true&"
import script from "./TipoRequestsTasksFormater.vue?vue&type=script&lang=js&"
export * from "./TipoRequestsTasksFormater.vue?vue&type=script&lang=js&"
import style0 from "./TipoRequestsTasksFormater.vue?vue&type=style&index=0&id=9e7813a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7813a2",
  null
  
)

export default component.exports